import { DateHelper } from './date.helper';

export class FormatHelper {
    public static stringToMonetaire(chaine: string) {
        return parseFloat(chaine);
    }

    public static toChaineMonetaire(montant: number | string, avecDevise: boolean = false): string {
        if (montant === null) {
            montant = 0;
        }
        if (typeof montant === 'string') {
            montant = +montant;
        }
        // return montant.toFixed(2);
        // return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(montant);
        // ou
        if (avecDevise) {
            return montant.toLocaleString(undefined, {style: 'currency', currency: 'EUR'});
        } else {
            return montant.toLocaleString(undefined, {minimumFractionDigits: 2});
        }
    }

    public static formatNote(note: string) {
        return !!note ? parseInt(note).toFixed(2) : '0.00';
    }

    public static coursPopup(cours, isHideProf = false, isHideRoom = false): string {
        const seperateur = '\n'; // '\n'
        return (cours.eleve && cours.eleve.nom ? (cours.eleve.nom + (cours.eleve.prenom ? ' ' + cours.eleve.prenom : '')) + seperateur : '')
            + (cours.type ? 'Cours collectif' + seperateur : '')
            + (!isHideProf && cours.professeur ?
            'Prof : ' + (cours.professeur.nom ? cours.professeur.nom + ' ' : '')
            + (cours.professeur.prenom ? cours.professeur.prenom : '')
            + seperateur : '')
            + (cours.discipline && cours.discipline.libelle ? 'Discipline : ' + cours.discipline.libelle + seperateur : '')
        + (cours.cycleLibelle || cours.niveauLibelle ? 'Niveau : '
            + (cours.cycleLibelle ? cours.cycleLibelle : '')
            + (cours.cycleLibelle && cours.niveauLibelle ? ' / ' : '')
            + (cours.niveauLibelle ? cours.niveauLibelle : '')
            + seperateur : '')
        + (cours.horaireDebut && cours.horaireFin ?
            'Horaires : ' + DateHelper.minutesToHoursMin(cours.horaireDebut) + '-'
            + (cours.horaireFin ? DateHelper.minutesToHoursMin(cours.horaireFin) : DateHelper.minutesToHoursMin(cours.horaireDebut + cours.duree)) + seperateur
            : '')
            + (!isHideRoom && cours.salle && cours.salle.nom ?
                'Salle : ' + cours.salle.nom + seperateur: '');
    }
}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/helpers/format.helper.ts